import { Outlet } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const Layout = () => {
  return (
    <div
      className="flex min-h-screen flex-col bg-white text-apicon-ink"
      data-testid="app-layout"
    >
      <Navbar />
      <main className="flex-1" data-testid="app-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
